import { ComponentStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

const { modal: { bgColorContent } } = primaryColor

// You can also use the more specific type for
// a single part component: ComponentSingleStyleConfig
export const Popover: ComponentStyleConfig = {
  baseStyle: {
    ...baseTheme.components.Popover.baseStyle,
  },
  sizes: {
    base: {
      fontSize: 2,
      px: 3, // <-- px is short for paddingLeft and paddingRight
      py: 2, // <-- py is short for paddingTop and paddingBottom
    },
    md: {
      fontSize: 'md',
      px: 6, // <-- these values are tokens from the design system
      py: 4, // <-- these values are tokens from the design system
    },
  },
  variants: {
    responsive: {
      content: {
        w: 'auto',
      },
      body: {
        maxWidth: 150,
        width: 150,
        bg: bgColorContent,
        borderRadius: '4px',
        borderWidth: 0,
        borderColor: 'transparent',
      }
    }
  },
  defaultProps: {
    size: 'base',
    variant: 'responsive'
  },
}
